$(document).ready(function () {
    $.ajax({
        type: "GET",
        url: "/products/faucet-water-filtration-system-wd-ctf-01.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(0)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(0)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/water-faucet-filter-wd-fc-01.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(1)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(1)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/long-lasting-water-faucet-filtration-system-wd-fc-06.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(2)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(2)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $(window).on("scroll", function () {
        var scrollTop = $(this).scrollTop();
        var offsetTop = $(".wd-compare-content").offset().top;
        if (scrollTop > offsetTop) {
            $(".wd-compare-header").css("display", "block");
        } else {
            $(".wd-compare-header").css("display", "none");
        }
    });

    var wd_compare_index;
    var pre_index;

    var window_width = $(window).width();
    if (window_width <= 1024) {
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(0)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(1)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
    }

    $(".wd-compare-detail-item-product-choose-select").click(function () {
        wd_compare_index = $(this).parents(".wd-compare-detail-item").index();
        pre_index = $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .find(`.wd-compare-detail-item-product-choose-card-item-active`)
            .attr("data-index");
        if (window_width <= 767) {
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "block"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "flex"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "block"
            );
            $("html").css("overflow", "hidden");
            $(".wd-compare").css("z-index", "99");
            $(this)
                .siblings(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #2179CA");
            $(this)
                .parents(".wd-compare-detail-item")
                .siblings()
                .find(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #e2e2e2");
        }
        $(this)
            .parents(".wd-compare-detail-items")
            .find(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideUp();
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideDown();
    });

    $(
        ".wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile"
    ).click(function () {
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card")
            .css("display", "none");
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-select-mobile")
            .css("border-bottom", "1px solid #e2e2e2");
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .css("display", "block");
        $(this).css("border-bottom", "1px solid #2179CA");
    });

    $(".wd-compare-detail-item-product-choose-card").mouseleave(function () {
        $(this).stop().slideUp();
    });
    $(".wd-compare-detail-item-product-choose-card-item").hover(
        function () {
            $(this).addClass("wd-compare-detail-item-product-choose-card-item-hover");
        },
        function () {
            $(this).removeClass(
                "wd-compare-detail-item-product-choose-card-item-hover"
            );
        }
    );
    $(".wd-compare-detail-item-product-choose-card-popup-close").click(
        function () {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
            $(".wd-compare").css("z-index", "auto");
        }
    );

    $(".wd-compare-detail-item-product-choose-card-item").click(function () {
        if (
            $(this).hasClass(
                "wd-compare-detail-item-product-choose-card-item-choosed"
            )
        ) {
            return false;
        }
        if (window_width <= 1024) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare").css("z-index", "auto");
        }
        if (window_width <= 767) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
        }

        var data_index = $(this).attr("data-index");
        if (data_index !== pre_index) {
            $(".wd-compare-detail-item-product-choose-card-items")
                .find(`[data-index="${pre_index}"]`)
                .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
            pre_index = data_index;
        }
        $(this)
            .siblings()
            .removeClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).addClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).removeClass(
            "wd-compare-detail-item-product-choose-card-item-choosed"
        );
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card-item")
            .each(function () {
                if ($(this).attr("data-index") === data_index) {
                    $(this).addClass(
                        "wd-compare-detail-item-product-choose-card-item-choosed"
                    );
                }
            });

        var product_title = $(this)
            .find(".wd-compare-detail-item-product-choose-card-item-title")
            .html()
            .trim();

        $(this)
            .parents(".wd-compare-detail-item-product-choose")
            .find(
                ".wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name"
            )
            .html(product_title);

        $(this)
            .parents(".wd-compare")
            .find(".wd-compare-header-item")
            .eq(wd_compare_index)
            .find(".wd-compare-header-item-title")
            .html(product_title);
        var product_value = $(this).data("value");
        $.ajax({
            type: "GET",
            url: "/products/" + product_value + ".js",
            dataType: "json",
            success: function (product) {
                var goods_price = (product.price_max / 100).toFixed(2);
                var goods_url = product.url;
                $(".wd-compare-product .wd-compare-detail-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-detail-item-product-price")
                    .html("$" + goods_price);
                $(".wd-compare-header .wd-compare-header-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-header-item-price")
                    .html("$" + goods_price);
            },
        });

        edit_info(product_title);
    });

    function edit_info(title) {
        if (title == "CTF-01") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-wd-ctf01-picture.png?v=1656314732"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-wd-ctf01-picture.png?v=1656314732"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/faucet-water-filtration-system-wd-ctf-01"
                );
            $(".wd-compare-detail-material .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Food-grade 304 Stainless-steel
    </div>`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
            1.6 GPM
        </div>`
                );
            $(".wd-compare-detail-certification .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">
        </div>`
                );

            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
                                  alt="">
                          </div>
                          <div class="wd-compare-detail-item-text">
                              4.92"L x 3.51"W x 12.51"H
                          </div>
            `
                );
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        5.08 pounds
    </div>
          `);
            $(".wd-compare-detail-water_outlet .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
                              Separate Faucet
                          </div>
            `
                );
            $(".wd-compare-detail-filter .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-text">
            KDF Filter Material
        </div>
            `
                );
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-longtext">
                              Reduction of chlorine, bad taste and odor
                          </div>
      `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-a">
                              <a href="https://www.waterdropfilter.com/products/countertop-faucet-system-replacement-filter-cff-01">
                                  <div class="wd-compare-detail-item-img">
                                      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/1_6fd241a0-d4cb-4925-b69b-e4a6e750a119.png?v=1667583991"
                                          alt="">
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                      WD-CFF-01
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                      12 months or 8,000 gallons
                                  </div>
                              </a>
                          </div>
          `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
            alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        $31.99
    </div>
            `);
        } else if (title == "FC-01") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/WD-FC-01-1.png?v=1643100149"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/WD-FC-01-1.png?v=1643100149"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/water-faucet-filter-wd-fc-01"
                );
            $(".wd-compare-detail-accessories .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-text">
          6 Types of Adapters for perfect fit
          Male threaded housing: M24(15/16") M21.5 M20.5(13/16) M18.5
          Female threaded housing: M22(55/64") M18.5
                          </div>
          `);
            $(".wd-compare-detail-material .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Lead-Free & Food-Grade Material
    </div>`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
            0.5 GPM
        </div>`
                );
            $(".wd-compare-detail-certification .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
        </div>`
                );

            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
                                  alt="">
                          </div>
                          <div class="wd-compare-detail-item-text">
                          8.06"L x 7.1"W x 2.9"H
                          </div>
            `
                );
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        1 pound
    </div>
          `);
            $(".wd-compare-detail-water_outlet .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Original Faucet
                          </div>
            `
                );
            $(".wd-compare-detail-filter .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-text">
            Integrating ACF (activated carbon fiber) 
        </div>
            `
                );
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-longtext">
          Reduction of chlorine, bad taste and odor
                          </div>
      `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-a">
                              <a href="https://www.waterdropfilter.com/products/replacement-filters-for-acf-faucet-filtration-system">
                                  <div class="wd-compare-detail-item-img">
                                      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/11_6e0ae9c6-ebbb-43ab-aae1-9f6c5e1a5e0c.png?v=1682308369"
                                          alt="">
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  WD-FF-01C-3
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  3 months or 320 gallons
                                  </div>
                              </a>
                          </div>
          `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
            alt="">
    </div>
    <div class="wd-compare-detail-item-text">
    $43.98
    </div>
            `);
        } else if (title == "FC-06") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/FC06-1.png?v=1680077567"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/products/FC06-1.png?v=1680077567"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/long-lasting-water-faucet-filtration-system-wd-fc-06"
                );
            $(".wd-compare-detail-material .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Food-grade 304 Stainless-steel
                          </div>`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
            0.5 GPM
        </div>`
                );
            $(".wd-compare-detail-certification .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
        </div>`
                );

            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
                                  alt="">
                          </div>
                          <div class="wd-compare-detail-item-text">
                          3.19"L x 10.35"W x 3.19"H
                          </div>
            `
                );
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        1.27 pounds
    </div>
          `);
            $(".wd-compare-detail-water_outlet .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Original Faucet
                          </div>
            `
                );
            $(".wd-compare-detail-filter .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-text">
            Integrating ACF (activated carbon fiber) 
        </div>
            `
                );
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-longtext">
          Reduction of chlorine, bad taste and odor
                          </div>
      `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-a">
                              <a href="https://www.waterdropfilter.com/products/tap-water-filter-replacement-filter-ff-03a">
                                  <div class="wd-compare-detail-item-img">
                                      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/waterdrop-ff03-img_1.png?v=1611900632"
                                          alt="">
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  WD-FF-03A-3
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  3 months or 320 gallons
                                  </div>
                              </a>
                          </div>
          `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
            alt="">
    </div>
    <div class="wd-compare-detail-item-text">
    $41.33
    </div>
            `);
        } else if (title == "CTF-05") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-CTF05_ECF-7070AC.png?v=1737539969"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-CTF05_ECF-7070AC.png?v=1737539969"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/faucet-water-filter/products/countertop-dispensing-faucet-water-filter-ctf05"
                );
            $(".wd-compare-detail-material .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Food-grade 304 Stainless-steel
                          </div>`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
                    1 GPM
        </div>`
                );
            $(".wd-compare-detail-certification .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
        </div>`
                );

            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
                                  alt="">
                          </div>
                          <div class="wd-compare-detail-item-text">
                          5"L x 7"W x 15"H
                          </div>
            `
                );
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        9.9 pounds
    </div>
          `);
            $(".wd-compare-detail-water_outlet .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Separate Faucet
                          </div>
            `
                );
            $(".wd-compare-detail-filter .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-text">
            Integrating ACF (activated carbon fiber) 
        </div>
            `
                );
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-longtext">
          Reduction of chlorine, bad taste and odor
                          </div>
      `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-a">
                              <a href="https://www.waterdropfilter.com/collections/faucet-water-filter/products/countertop-coarse-faucet-water-filter-replacement-filter-cff03">
                                  <div class="wd-compare-detail-item-img">
                                      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/1_76ff963a-c35c-4259-8a25-e75d3ed098b7.png?v=1729847611"
                                          alt="">
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  WD-CFF-03
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  6 months or 4,000 gallons
                                  </div>
                              </a>
                          </div>
          `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
            alt="">
    </div>
    <div class="wd-compare-detail-item-text">
    $63.98
    </div>
            `);
        } else if (title == "CTF-06") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WD-CTF06.png?v=1736412302"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WD-CTF06.png?v=1736412302"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/faucet-water-filter/products/countertop-dual-handoff-faucet-water-filter-ctf06"
                );
            $(".wd-compare-detail-material .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        Food-grade 304 Stainless-steel
                          </div>`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">
                    1 GPM
        </div>`
                );
            $(".wd-compare-detail-certification .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-kettle-nsf.jpg?v=1690160866" alt="">
        </div>`
                );

            $(".wd-compare-detail-product_dimesions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-svg">
                              <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835"
                                  alt="">
                          </div>
                          <div class="wd-compare-detail-item-text">
                          5"L x 7"W x 15"H
                          </div>
            `
                );
            $(".wd-compare-detail-item_weight .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-text">
        9.9 pounds
    </div>
          `);
            $(".wd-compare-detail-water_outlet .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-item-text">
            Separate Faucet
                          </div>
            `
                );
            $(".wd-compare-detail-filter .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
            <div class="wd-compare-detail-text">
            Integrating ACF (activated carbon fiber) 
        </div>
            `
                );
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-longtext">
          Reduction of chlorine, bad taste and odor
                          </div>
      `);
            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
          <div class="wd-compare-detail-item-a">
                              <a href="https://www.waterdropfilter.com/collections/faucet-water-filter/products/countertop-coarse-faucet-water-filter-replacement-filter-cff03">
                                  <div class="wd-compare-detail-item-img">
                                      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/1_76ff963a-c35c-4259-8a25-e75d3ed098b7.png?v=1729847611"
                                          alt="">
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  WD-CFF-03
                                  </div>
                                  <div class="wd-compare-detail-item-text">
                                  6 months or 4,000 gallons
                                  </div>
                              </a>
                          </div>
          `);
            $(".wd-compare-detail-average .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
        <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-average-svg.svg?v=1682313835"
            alt="">
    </div>
    <div class="wd-compare-detail-item-text">
    $63.98
    </div>
            `);
        }
    }
});
